import axios from 'axios';

import config from '../config';
import { buildHeaders } from '../redux/buildAuthHeader';

const axiosOptions = {
  baseURL: config.apiHost,
  withCredentials: true
};
const api = axios.create({ ...axiosOptions });
const apiBase = axios.create({ ...axiosOptions });

const requestParams = [
  (request) => {
    request.headers = {
      ...request.headers,
      ...buildHeaders()
    };
    return request;
  },
  (error) => Promise.reject(error)
];

api.interceptors.request.use(...requestParams);
apiBase.interceptors.request.use(...requestParams);

export const apiWithoutInterceptors = apiBase;

// --- REFRESH TOKEN LOGIC ---
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve();
    }
  });
  failedQueue = [];
};

api.interceptors.response.use(
  (response) => response?.data,
  async (error) => {
    const originalRequest = error.config;

    if (error.response && error.response.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        }).then(() => api(originalRequest));
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        await apiBase.post('/sessions/refresh'); // refreshToken é enviado via cookie HttpOnly
        processQueue(null);
        return api(originalRequest);
      } catch (refreshError) {
        processQueue(refreshError);
        // Opcional: redirecionar para login
        window.location.href = '/';
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);

export default api;



// WEBPACK FOOTER //
// ./src/utils/api.js